export function Cancel(organizationID: number): string {
	return `/v1/organizations/${organizationID}/subscriptions/cancel`;
}

export function CreateBatch(organizationID: number): string {
	return `/v1/organizations/${organizationID}/subscriptions/batch`;
}

export function ExportSubscriptions(organizationID: number): string {
	return `/v1/organizations/${organizationID}/subscriptions/export`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/subscriptions`;
}

export function ListPossiblePaymentMethods(organizationID: number, subscriptionID: number): string {
	return `/v1/organizations/${organizationID}/subscriptions/${subscriptionID}/payment-methods`;
}

export function ListSubscriptions(): string {
	return `/v1/accounts/self/subscriptions`;
}

export function ListUserAndWardsSubscriptions(organizationID: number): string {
	return `/v1/organizations/${organizationID}/users/self/subscriptions`;
}

export function Reactivate(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/subscriptions/${ID}/reactivate`;
}

export function SetPaymentMethod(organizationID: number, subscriptionID: number): string {
	return `/v1/organizations/${organizationID}/subscriptions/${subscriptionID}/set-payment-method`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/subscriptions/${ID}`;
}

export function Update(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/subscriptions/${ID}`;
}

export function UpdateProductRecipient(organizationID: number, subscriptionID: number): string {
	return `/v1/organizations/${organizationID}/subscriptions/${subscriptionID}/update-product-recipient`;
}

